export const formatDeliveredTimestamp = (text: string): string => {
  // Match pattern: Month Day, Year Time (e.g., "January 20, 2024 11:59 PM")
  // Add <br> after the year (after 4 digits followed by space)
  return text.replace(/(\d{4})\s+/, '$1<br>');
};

export const formatTimeRange = (text: string): string => {
  // Add <br> after "between", case insensitive
  return text.replace(/(between)\s+/i, '$1<br>');
};

export const getOrderUrl = (orderStatusUrl: string, orderReference: string | null, tokenParam: string) => {
  // Check if the new order status page feature flag is enabled
  if (window.getSiteSettings?.()?.orderTrackingEnabled) {
    const newUrl = `/pages/order-status?order_reference=${orderReference || ''}${tokenParam}`;
    return newUrl;
  } else {
    return orderStatusUrl;
  }
};

export const getInitialActiveTab = (orderData: { shipments?: Array<{ tracking_number: string }> } | null): number => {
  if (!orderData?.shipments) return 0;

  const urlParams = new URLSearchParams(window.location.search);
  const trackingNumber = urlParams.get('tracking_number');

  if (trackingNumber) {
    const shipmentIndex = orderData.shipments.findIndex((shipment) => shipment.tracking_number === trackingNumber);
    if (shipmentIndex !== -1) {
      return shipmentIndex;
    }
  }

  return 0;
};
